// pages/Products.js
import React, { useState } from 'react';
// import '../styles/Products.css';

const books = [
  {
    id: 1,
    grade: 1,
    title: "Introduction to Computers",
    description: "A fun-filled journey into the world of computers for young minds",
    cover: "/api/placeholder/200/300",
    features: ["Basic computer parts", "Mouse and keyboard skills", "Simple games"]
  },
  // Add more books here
];

export default function Products() {
  const [activeBook, setActiveBook] = useState(null);

  return (
    <div className="products">
      <section className="books-hero">
        <h1>Educational Books</h1>
        <p>Comprehensive computer education from Grade 1 to 10</p>
      </section>

      <div className="books-carousel">
        {books.map(book => (
          <div 
            key={book.id} 
            className={`book-card ${activeBook === book.id ? 'active' : ''}`}
            onClick={() => setActiveBook(book.id)}
          >
            <div className="book-cover">
              <img src={book.cover} alt={book.title} />
            </div>
            <div className="book-info">
              <h3>Grade {book.grade}</h3>
              <h2>{book.title}</h2>
              <p>{book.description}</p>
              <ul>
                {book.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <button className="explore-btn">Explore Book</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}